import { cva } from 'class-variance-authority';

import { cn } from '@heidi/utils';

/**
 * Relies on Checkbox, Switch and RadioGroupItem setting `peer`, so the Label
 * must follow its toggle. Cursors need `[for]` (an unbound Label toggles
 * nothing); dimming doesn't (it's about looking paired). `has-*` gives a
 * wrapping Label the cursors only: opacity on it would also fade the toggle
 * inside, which already fades itself when disabled. All are role-scoped: other
 * DS parts set `peer` too (CollapsibleCard, Sidebar), and an info-tooltip
 * button can sit in a Label.
 */
export const labelControlStateClasses = cn(
  'peer-[:is([role=checkbox],[role=radio],[role=switch]):disabled]:opacity-70',
  'peer-[:is([role=checkbox],[role=radio],[role=switch]):enabled]:[&[for]]:cursor-pointer',
  'peer-[:is([role=checkbox],[role=radio],[role=switch]):disabled]:[&[for]]:cursor-not-allowed',
  'has-[:is([role=checkbox],[role=radio],[role=switch]):enabled]:cursor-pointer',
  'has-[:is([role=checkbox],[role=radio],[role=switch]):disabled]:cursor-not-allowed'
);

export const labelVariants = cva(cn('text-sm', labelControlStateClasses));
